import { render } from "./CreditStatementTransactions.vue?vue&type=template&id=2b0bb5ec&scoped=true"
import script from "./CreditStatementTransactions.vue?vue&type=script&lang=js"
export * from "./CreditStatementTransactions.vue?vue&type=script&lang=js"

import "./CreditStatementTransactions.vue?vue&type=style&index=0&id=2b0bb5ec&scoped=true&lang=css"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0bb5ec"]])

export default __exports__